import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateLocationTypeRequest extends BaseUpdateRequest {
    name = '';
}